import {Component, OnInit} from '@angular/core';
import {DataService} from '../../../Services/data.service';
import { Router } from '@angular/router';
import { AppConfigService } from '../../../Services/app-config.service';
import { PermissionsService } from '../../../Services/permissions.service';
import { HttpErrorResponse } from '@angular/common/http';
import { ResponseModel } from '../../../DataModels/response-model';
import { DateFilterService } from '../../../Services/dateFilter.service';
import { NgbPaginationConfig } from '@ng-bootstrap/ng-bootstrap';
import { PagerStateService } from '../../../Services/pager-state.service';
import { NgbpaginationConfigService } from '../../../Services/ngbpagination-config.service';
import { BsToastService} from '../../../Services/bs-toast-service';
import {Title} from '@angular/platform-browser';
import {ListPageBase} from '../../list-page-base';

@Component({
  selector: 'app-entity-list',
  templateUrl: './entity-list.component.html',
  styleUrls: ['./entity-list.component.css'],
  standalone: false
})
export class EntityListComponent extends ListPageBase implements OnInit {
  constructor(
    private aTable: DataService,
    private notification: BsToastService,
    private aRoute: Router,
    public p: PermissionsService,
    private dateFilter: DateFilterService,
    private ngbConfig: NgbPaginationConfig,
    private pagerConfig: NgbpaginationConfigService,
    private titleService: Title
  ) {
    super();
    this.ngbConfig = this.pagerConfig.getNgbPaginationConfig();
  }

  entityCount = 0;
  vm: any = [];



  // shows JSON pulled from api when true
  developerView = false;

  ngOnInit() {
    this.restorePagerState();
    this.titleService.setTitle($localize`:Entity List@@entityList:Entity List`);
    this.vm.list = [];
    this.getData();
  }


  getData() {
    let paramString = '?search=' + (this.vm.searchTerm ? this.vm.searchTerm : '');
    paramString += '&fromDate=' + (this.vm.fromDate ? this.dateFilter.GetDateFormat(this.vm.fromDate) : '');
    paramString += '&toDate=' + (this.vm.toDate ? this.dateFilter.GetDateFormat(this.vm.toDate) : '');
    paramString += '&pageNumber=' + (this.page !== 0 ? this.page - 1 : 0);
    paramString += '&pageSize=' + this.pageSize;

    this.aTable.getApiListData('entity', paramString).subscribe(
      (result: ResponseModel) => {
        this.vm.list = result.Data;
        this.totalRecords = result.totalRecords;
        this.paginate(false);

        this.entityCount = this.vm.list.length;
        this.vm.loaded = true;
      },
      (error: HttpErrorResponse) => {
        console.log(error);
      },
      () => {}
    );
  }

  onNavigate(aID: string) {
    this.aRoute.navigate(['entity-form', { id: aID }]).then();
  }

  // ----------------- Server side paging --------------------

  protected fetchPage(): void {
    this.getPagedApiData();
  }

  getPagedApiData() {
    let paramString = '?search=' + (this.vm.searchTerm ? this.vm.searchTerm : '');
    paramString += '&fromDate=' + (this.vm.fromDate ? this.dateFilter.GetDateFormat(this.vm.fromDate) : '');
    paramString += '&toDate=' + (this.vm.toDate ? this.dateFilter.GetDateFormat(this.vm.toDate) : '');
    paramString += '&pageNumber=' + (this.page !== 0 ? this.page - 1 : 0);
    paramString += '&pageSize=' + this.pageSize;

    this.aTable.getApiListData('entity', paramString).subscribe(
      (result: ResponseModel) => {
        this.vm.list = result.Data;
        this.totalRecords = result.totalRecords;
        this.paginate(false);

        this.entityCount = this.vm.list.length;
        this.vm.loaded = true;
      },
      (error: HttpErrorResponse) => {
        console.log(error);
      },
      () => {}
    );
  }

  serverSearch(value) {
    this.vm.searchTerm = value.searchTerm;
    this.vm.fromDate = value.fromDate;
    this.vm.toDate = value.toDate;
    this.page = 1;
    this.getPagedApiData();
  }

  clearServerSearch(value) {
    this.vm.searchTerm = value.searchTerm;
    this.vm.fromDate = value.fromDate;
    this.vm.toDate = value.toDate;
    this.page = 1;
    this.getPagedApiData();
  }

  hideSearch() {
    this.vm.searchHidden = !this.vm.searchHidden;
  }

}
